export const PRIVACY_CONSENT_FILES = {
    EMAIL_CONSENT: "consentToEmail",
    CALL_CONSENT: "consentToCall",
    MESSAGE_CONSENT: "consentToMessage",
    PATIENT_STATUS: "status"
}